<template>
  <div class="container">
    <div class="page">
      <div class="header_nav">
        <div>
          <router-link class="router_link" to="/Home/JC">合作厂商一</router-link>
        </div>
        <div>合作厂商二</div>
      </div>
      <div class="partner_img">
        <div class="img">
          <img src="../assets/images/hl/1.png">
        </div>
        <div class="img">
          <img src="../assets/images/hl/2.png">
        </div>
        <div class="img">
          <img src="../assets/images/hl/3.png">
        </div>
      </div>
      <div class="section">
        <div>
          <div class="title">简介
            <div></div>
          </div>
          <div class="intro">
            某物流有限公司于2004年成立，与富邦科技有限公司，VELLEDQ有限公司、Pascal Electric Vehicle Connection Limited等成为合作伙伴。生产包括车加工、装配、测试、实验等方面。目前也有较多成熟产品，包括国标/欧美标交直流充电枪/交直流桩端车端插座、国标/欧美标模式2交流充电枪、高压配电盒（PDU）、高压动力电池切段单元（BDU）、车载手机无线充电、汽车精密零部件等。
          </div>
        </div>
        <div>
          <div class="title">企业资质
            <div></div>
          </div>
          <div class="intro">
            2008年3月通过ISO9001质量管理体系认证，2015年10月通过TS16949汽车产品质量体系认证，2017年换证IATF16949证书。2017年通过ISO14001环境管理体系认证。2016年5月为全国首家通过新国际直流充电接口产品认证的企业，建有先进的研发中心和检测实验室，已取得发明专利3项，外观结构实用新型专利45项，注册商标3项。2016年底通过了高新技术企业和科技型中小企业的认定。
          </div>
        </div>
        <div>
          <div class="title">生产设备
            <div></div>
          </div>
          <div class="machine">
            <div class="img">
              <img src="../assets/images/hl/4.png">
            </div>
            <div class="img">
              <img src="../assets/images/hl/5.png">
            </div>
            <div class="img">
              <img src="../assets/images/hl/6.png">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  }
}
</script>

<style scoped>
/* 二级导航栏 */
.header_nav>div:nth-child(2) {
  background:rgba(0,0,0,1);
  color: #fff;
}
.header_nav>div:nth-child(1):hover {
  color: #a3a3a3;
  cursor: pointer;
}
/* 简介 */
/* 生产设备 */
.machine {
  display: flex;
  justify-content: space-between;
  margin-left: 22px;
  margin-right: 22px;
}
.machine .img {
  width: 300px;
  height: 200px;
}
</style>